import React, { Component, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useHistory } from "react-router-dom";
//import { Slide } from 'react-slideshow-image';
import { fetchDefault } from './Utils.js';
import Cookies from 'js-cookie';

const useStyles = makeStyles(theme => ({
    fullImage: {
        //position: 'fixed',
        marginTop: 8,
    },
    lineSpacing: {
        marginTop: 30,
        marginBottom: 30,
    },
    buttonSpace: {
        margin: theme.spacing(0.5),
        fontSize: 20
    },
}));

export default function Display(props) {
    const classes = useStyles();
    let history = useHistory();
    const [storeName, setStoreName] = React.useState('');

    const properties = {
        duration: 5000,
        transitionDuration: 500,
        infinite: true,
        indicators: true,
        arrows: true,
        pauseOnHover: true,
        onChange: (oldIndex, newIndex) => {
            console.log(`slide transition from ${oldIndex} to ${newIndex}`);
        }
    }

    useEffect(() => {
        fetchDefault('/User/GetStoreName',
            (data) => {
                setStoreName(data.storeName);
            }
        );

        return () => {
        }

    }, []);

    const [popupOpen, setPopupOpen] = React.useState((props.match.params.charging == "disconnected") ? true : false);
    
    const PressBeginner = () => {
        setPopupOpen(false);
        window.location.assign("/signUp");
    }

    const PressNotBeginner = () => {
        setPopupOpen(false);
        window.location.assign("/signIn");
    }
    
    return (
        <div /*onClick={() => setPopupOpen(true)}*/>
            <Dialog aria-labelledby="simple-dialog-title" open={popupOpen}>
                <DialogTitle id="simple-dialog-title">카페를 처음 이용하시나요?</DialogTitle>
                <DialogActions>
                    <Button onClick={PressBeginner} color="primary">
                        <Typography variant="h5">
                            예, 처음 이용합니다.
                        </Typography>
                    </Button>
                    <Button onClick={PressNotBeginner} color="primary">
                        <Typography variant="h5">
                            아니요
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <div style={{ marginTop:8 }}>
                <img width="100%" alt="loading..." src={require('../images/logo_v1.1.png')} style={{ width: 120 }} />
            </div>
            {/* 
                <img width="100%" alt="loading..." src={require('../images/main_m.jpg')} className={classes.fullImage} />
            */}

            <div>
                <img width="100%" alt="loading..." src={require('../images/main_m.jpg')} className={classes.fullImage} />
            </div>

            {/*<Slide {...properties}>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/main_m.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/1_display.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/2_display.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/3_display.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/4_display.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*    <div className="each-slide">*/}
            {/*        <img width="100%" alt="loading..." src={require('../images/5_display.jpg')} className={classes.fullImage} />*/}
            {/*    </div>*/}
            {/*</Slide>*/}

            <Typography variant="h4" className={classes.lineSpacing}>24시 스터디 카페 ( {storeName} )</Typography>
            <Typography variant="h6" className={classes.lineSpacing}>“공부, 독서, 휴식 등 다양한 방법으로 이용하세요! 편안하고 쾌적한 공간을 제공하겠습니다!”</Typography>

            {window.location.hostname != '192.168.0.2' ? (<div></div>) : (<div>
                <Typography variant="h6" className={classes.lineSpacing}>먼저 이 테블릿을 들고 <strong>입장</strong>하세요. (충전기를 빼주세요.)</Typography>
                <Typography variant="h6" className={classes.lineSpacing}>카페를 둘러보신 후 편하신 자리에 앉으셔서, 이 테블릿으로 카페 이용방법을 천천히 확인해보세요.</Typography>
                <Typography variant="h6" className={classes.lineSpacing}>테블릿으로 자리이용, 사물함이용 등 카페의 모든 시설을 이용할 수 있습니다.</Typography>
            </div>)}

            <Typography variant="h6" style={{ marginTop: 20 }}>카페를 처음 이용하시나요? ▶ <Button onClick={() => window.location.assign('/signUp')} variant="outlined" color="primary" className={classes.buttonSpace}>
                회원가입
            </Button></Typography>
            <Typography variant="h6" style={{ marginTop: 15, marginBottom: 30 }}>기존 회원 ▶ <Button onClick={() => window.location.assign('/signIn')} variant="outlined" color="primary" className={classes.buttonSpace}>
                로그인
            </Button></Typography>
            
        </div>
    );
    
}



// WEBPACK FOOTER //
// ./src/components/Display.js